import { useEffect, useState } from "react";
import { useAPIs } from "../../apis/APIsConfig";
import { useNavigate, useParams } from "react-router-dom";

import {
  getPublicReporteEstadoCuenta,
  getPublicReporteEstadoCuentaPublicSMS,
  getResumenCuentaSMS,
} from "../../services/dashboard";

import InputMask from "react-input-mask";
import GlobalLoading from "../common/GlobalLoading";
import { getPreguntasSeguridad, getResumenCuentaCedula, getResumenRespuestas, validarAfiliado, validarRespuestas } from "../../services/user";
import { formatDate } from "../../utils/moment";
import { convertToMoney } from "../../utils/number";
import { useForm } from "../../utils/hooks";
import Reaptcha from "reaptcha";
import { useGlobalStore } from "../../utils/global";

const PublicSMSGUID = () => {
  useAPIs();
  const navigate = useNavigate();

  var captchaRef;

  const [formState, setError, changeHandler, reset] = useForm({
    cedula: "",
    cedulaConfirm: "",
    captcha: false,
  });

  const { showNotification } = useGlobalStore();
  const [preguntas, setPreguntas] = useState<any[]>([]);
  const [list, setList] = useState<any[]>([]);
  const { guid } = useParams();

  useEffect(() => {
    var launcher = document.getElementById("launcher");
    launcher?.remove();

    var botprofrm = document.getElementById("botprofrm");
    botprofrm?.remove();

    if (guid) {
      getResumenCuentaSMS(guid).then((resumen) => {
        debugger;
        if (resumen) {
          formState.data.cedulaConfirm = resumen.data.value.cedula
        } else {
          navigate("/", { replace: true });
        }
      });
    }
  }, [guid]);

  function disableButton() {
    return !formState.data.cedula || !formState.data.captcha;
  }

  function submitForm() {
    if (formState.data.cedulaConfirm !== formState.data.cedula) {
      showNotification({
        title: "Error",
        message: `Cédula inválida.`,
        isError: true,
        duration: 0
      });
    } else {
      getResumenCuentaCedula(
        formState.data.cedula
      ).then((res) => {
        if (res) {
          setList(res.data.value);
        }
      });
    }
  }

  function onVerify(recaptchaResponse) {
    changeHandler("captcha", true)();
  }

  function handleChange(codPreguntas: number) {
    return (changeEvent) => {
      const pregs = [...preguntas];
      pregs.find((f) => f.codPreguntas === codPreguntas)["valorRespuesta"] =
        changeEvent.target.value;
      setPreguntas(pregs);
    };
  }

  function download(fechaCorte) {
    getPublicReporteEstadoCuentaPublicSMS(
      fechaCorte,
      formState.data.cedula,
      preguntas.map((preg) => {
        return {
          codPregunta: preg.codPreguntas,
          valorRespuesta: preg.valorRespuesta,
        };
      }), 2
    );
  }

  return (
    <>
      <GlobalLoading />
      <div className="block pt-10 lg:pt-8 pb-[128px]">
        <h1 className="text-primary-100 font-bold mb-4">
          Consulta de Estado de Cuenta
        </h1>
        {guid && list.length === 0 && (
          <p className="text-gray-70 text-body-1 font-body font-normal">
            Antes de continuar favor de{" "}
            <span className="font-semibold">ingresar su número de cédula</span>
          </p>
        )}
      </div>
      {guid && list.length === 0 && (
        <form
          className="block space-y-8"
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <div className="form-group">
            <label>Digita tú número de cédula</label>
            <InputMask
              type="text"
              className="form-control large"
              placeholder="Ingresa tu documento"
              value={formState.data.cedula}
              onChange={changeHandler("cedula", undefined, "-")}
              mask="999-9999999-9"
              maskPlaceholder={"_"}
            />
          </div>

          {preguntas.map((pregunta, index) => (
            <div className="form-group" key={index}>
              <label className="checkbox-radio">
                <p className="font-body font-normal">{pregunta.descripcion}</p>
              </label>

              {pregunta.respuestas.map((respuesta, indexResp) => (
                <div className="form-group mb-2" key={indexResp}>
                  <label className="checkbox-radio">
                    <input
                      type="radio"
                      value={respuesta.valor}
                      name={"pregunta" + pregunta.codPreguntas}
                      onChange={handleChange(pregunta.codPreguntas)}
                    />
                    <p>{respuesta.valor}</p>
                  </label>
                </div>
              ))}
            </div>
          ))}

          <Reaptcha
            ref={(e) => (captchaRef = e)}
            sitekey={process.env.REACT_APP_SITE_KEY}
            onVerify={onVerify}
          />

          <button
            type="button"
            onClick={submitForm}
            disabled={disableButton()}
            className="btn btn-primary btn-large"
          >
            Continuar
          </button>
        </form>
      )}

      {/* LISTA */}
      <div className="block pt-10 lg:pt-8 pb-[128px]">
        {list.length > 0 && (
          <nav className="pb-6 lg:pb-6">
            <ol className="breadcrumb">
              <li className="breadcrumb-item active">Mi Estado de Cuenta</li>
            </ol>
          </nav>
        )}
        <ul className="info-card-download">
          {list.map((item, index) => (
            <li key={index}>
              <div>
                <div className="icon-container">
                  <i className="icon icon-cash text-primary-90 text-[20px]"></i>
                </div>
                <div className="description">
                  <p>Al corte {formatDate(item.fechaCorte, "DD-MM-YYYY")}</p>
                  <h5 className="lead font-semibold">
                    RD$ {convertToMoney(item.monto)}
                  </h5>
                </div>
              </div>
              <button
                onClick={() => download(item.fechaCorte)}
                className="btn btn-secondary btn-medium hidden lg:inline-flex"
              >
                Descargar
              </button>
              <button
                className="block lg:hidden"
                onClick={() => download(item.fechaCorte)}
              >
                <i className="icon icon-download text-gray-50 text-[26px]"></i>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default PublicSMSGUID;
